
<mat-card class="product-card" appearance="outlined">
    <!-- (click)="showProductDetail(product.productId)" -->
    <!--TODO: ProductPicture laden-->

    <!-- <button
                class="remove-btn"
                (click)="deleteProductFromList(itemInfo.id, itemInfo.displayType)"
            ><img src="assets/img/icons/trash.png" alt="Delete item"></button> -->

    <red-trash-can-button class="btn-position" [class]="'btn-shadow'"
        (click)="deleteProductFromList(itemInfo.id, itemInfo.displayType)"></red-trash-can-button>

    <div class="imageContainer" (click)="showDetailPage(itemInfo.id, itemInfo.displayType)">
        <ng-container>
            <app-secure-image class="productImage" *ngIf="itemInfo.fileId != null" [productList]="true"
                [displayItem]="true" [fileId]="itemInfo.fileId" [src]="itemInfo.pictureUrl">
            </app-secure-image>
            <img *ngIf="itemInfo.fileId == null" [src]="getProductPreviewPicture(itemInfo)" alt="Produktbild" />
        </ng-container>
    </div>

    <!--div *ngIf="product.hasActiveMalfunctions"
                style="width: 2em; height: 2em; z-index: 1; left: 0;top: 0; position: absolute; margin-bottom: 0;"
                class="warning" matTooltip="Für dieses Produkt liegt eine Störung vor." [matTooltipPosition]="'left'"
                matTooltipClass="tooltip-warning" (click)="routeToMalfunctionOverview(product.productId)"></div-->

    <div [style]="'display: flex; align-items: center; width: 204px;'">
        <!-- <img [src]="getProductPreviewPicture(itemInfo)" alt="Produktbild" [style]="'height:40px; width: 40px'"/> -->
        <div [style]="'max-width: 100%;'">
            <div class="product-name" (click)="showDetailPage(itemInfo.id, itemInfo.displayType)">
                <p class="name-wrapping" matTooltip="{{ itemInfo.bookMarkName }}" matTooltipClass="header-tooltip "
                    style="margin: 0">
                    {{ itemInfo.bookMarkName }}
                </p>
            </div>
            <div class="organisation-name" (click)="showDetailPage(itemInfo.id, itemInfo.displayType)">
                <p class="name-wrapping" matTooltip="{{ itemInfo.organisationName }}" matTooltipClass="header-tooltip "
                    style="margin: 0">
                    {{ itemInfo.organisationName }}
                </p>
            </div>
        </div>
    </div>

    <div>
        <app-star *ngIf="itemInfo.displayType == 1" [rating]="itemInfo.rating" [ratingCount]="itemInfo.ratingCount"
            (click)="showDetailPage(itemInfo.id)">
        </app-star>
    </div>
</mat-card>